//src/services/authService.js

import api from './api.js';

export const authService = {
  register: (email) => api.post('/auth/register', { email }, false),
  verify: (email, code) => api.post('/auth/verify', { email, code }, false),
  complete: (data) => api.post('/auth/complete', data, false),
  resendCode: (email) => api.post('/auth/resend-code', { email }, false),
  // rememberMe (optional boolean) controls session length on the server:
  //   true  → long-lived "stay logged in" session
  //   false → short session
  // Passed through to POST /auth/login. Still auth=false (no token yet).
  login: (email, password, rememberMe = false) =>
    api.post('/auth/login', { email, password, rememberMe }, false),
  restoreAccount: (email, password) => api.post('/auth/restore-account', { email, password }, false),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }, false),
  verifyReset: (email, code) => api.post('/auth/verify-reset', { email, code }, false),
  resetPassword: (email, code, password) => api.post('/auth/reset-password', { email, code, password }, false),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  updateThemePreference: (prefersDarkMode) => api.put('/auth/theme-preference', { prefersDarkMode }),
  deleteAccount: (confirmation) => api.post('/auth/delete-account', { confirmation }),
  // Silently exchange the current token for a fresh one. Delegates to the
  // single-flight refresh in api.js so the proactive (activity-driven) and
  // reactive (401 backstop) refresh paths share one in-flight request.
  // Resolves to { token, user } on success or null on failure.
  refresh: () => api.refresh(),
};

export default authService;